// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../../reason/common/Theme/Theme__Color__Vars.bs.js");
var PropertyWizard__WarningHeader = require("./PropertyWizard__WarningHeader.bs.js");

function PropertyWizardRelay__BroadcastQuietSellerWarning(props) {
  switch (props.privacy) {
    case "ANONYMOUS" :
        return JsxRuntime.jsx(PropertyWizard__WarningHeader.make, {
                    icon: JsxRuntime.jsx(Icon__Jsx3.make, {
                          icon: "AttentionAlt",
                          size: 30,
                          color: Theme__Color__Vars.black
                        }),
                    headingText: "Broadcasting this property will reveal your name",
                    variant: "Warning",
                    children: JsxRuntime.jsx(Text__Jsx3.make, {
                          as_: "div",
                          children: "You originally used Hide My Name on this seller to  remain anonymous. Promoting to a broadcast will reveal your identity on all previous matches and conversations."
                        })
                  });
    case "HIDDEN" :
    case "NORMAL" :
        return null;
    
  }
}

var make = PropertyWizardRelay__BroadcastQuietSellerWarning;

exports.make = make;
/* Icon__Jsx3 Not a pure module */
